var installedModules = {};
var moduleToHandlerMapping = {
	15146: {
		getter: () => (__webpack_require__.e(4041).then(() => (() => (__webpack_require__(14041))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^19.1.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	16903: {
		getter: () => (__webpack_require__.e(7685).then(() => (() => (__webpack_require__(87685))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	17624: {
		getter: () => (__webpack_require__.e(2913).then(() => (() => (__webpack_require__(52913))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.23.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	38844: {
		getter: () => (Promise.all([__webpack_require__.e(7978), __webpack_require__.e(4209)]).then(() => (() => (__webpack_require__(14209))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^10.36.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@sentry/react",
	},
	52434: {
		getter: () => (__webpack_require__.e(763).then(() => (() => (__webpack_require__(43144))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^19.1.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	57668: {
		getter: () => (Promise.all([__webpack_require__.e(4388), __webpack_require__.e(5257), __webpack_require__.e(1024), __webpack_require__.e(8724), __webpack_require__.e(8196), __webpack_require__.e(3555), __webpack_require__.e(7001)]).then(() => (() => (__webpack_require__(48956))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mikolajszabatin/raks-ui-components",
	},
	1002: {
		getter: () => (__webpack_require__.e(6755).then(() => (() => (__webpack_require__(6755))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.5.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@testing-library/user-event",
	},
	27431: {
		getter: () => (__webpack_require__.e(4733).then(() => (() => (__webpack_require__(47114))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.13.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/x-license",
	},
	28618: {
		getter: () => (__webpack_require__.e(1421).then(() => (() => (__webpack_require__(91421))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^7.1.10",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-intl",
	},
	48011: {
		getter: () => (Promise.all([__webpack_require__.e(1316), __webpack_require__.e(8350), __webpack_require__.e(726), __webpack_require__.e(6866)]).then(() => (() => (__webpack_require__(6866))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.4.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/material",
	},
	51746: {
		getter: () => (Promise.all([__webpack_require__.e(5233), __webpack_require__.e(6388)]).then(() => (() => (__webpack_require__(46388))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.14.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/x-charts",
	},
	56234: {
		getter: () => (__webpack_require__.e(5910).then(() => (() => (__webpack_require__(55910))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.3.4",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query",
	},
	58978: {
		getter: () => (Promise.all([__webpack_require__.e(1316), __webpack_require__.e(9275), __webpack_require__.e(726), __webpack_require__.e(5907)]).then(() => (() => (__webpack_require__(69542))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.14.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/x-date-pickers-pro",
	},
	75132: {
		getter: () => (__webpack_require__.e(3464).then(() => (() => (__webpack_require__(23464))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.11.7",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dayjs",
	},
	90363: {
		getter: () => (__webpack_require__.e(9263).then(() => (() => (__webpack_require__(29263))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^10.15.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "framer-motion",
	},
	93332: {
		getter: () => (Promise.all([__webpack_require__.e(1316), __webpack_require__.e(8350), __webpack_require__.e(5233), __webpack_require__.e(9275), __webpack_require__.e(4786), __webpack_require__.e(5999), __webpack_require__.e(9632)]).then(() => (() => (__webpack_require__(95999))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.14.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/x-data-grid-premium",
	},
	79632: {
		getter: () => (__webpack_require__.e(10).then(() => (() => (__webpack_require__(90010))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.14.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/x-data-grid-pro",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"2071": [
		15146,
		16903,
		17624,
		38844,
		52434,
		57668
	],
	"2765": [
		15146
	],
	"3144": [
		15146
	],
	"3932": [
		15146,
		52434
	],
	"4265": [
		15146,
		52434
	],
	"5146": [
		15146
	],
	"7001": [
		1002,
		27431,
		28618,
		48011,
		51746,
		56234,
		58978,
		75132,
		90363,
		93332
	],
	"7114": [
		15146
	],
	"7527": [
		15146
	],
	"7622": [
		15146,
		52434
	],
	"8029": [
		15146,
		52434
	],
	"8330": [
		15146
	],
	"9200": [
		15146,
		52434
	],
	"9382": [
		1002,
		15146,
		16903,
		17624,
		27431,
		28618,
		38844,
		48011,
		51746,
		52434,
		56234,
		58978,
		75132,
		90363,
		93332
	],
	"9632": [
		79632
	],
	"9855": [
		15146,
		52434,
		79632
	],
	"9908": [
		15146
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}